export default function scrollDown(element, data) {
    element.addEventListener('click', function() {
        window.scrollBy({
            top: 600,
            behavior: 'smooth'
        });
    });
};
